<template>
    <aside class="right-side">
        <section class="content-header">
            <h1 v-if="header">{{header}}</h1>

            <breadcrumbs />
        </section>

        <section class="content">
            <router-view />
        </section>
    </aside>
</template>

<script>
    import Breadcrumbs from "./Breadcrumbs.vue";

    export default {
        components: {
            Breadcrumbs
        },
        computed: {
            header(){
                return this.$route.meta && this.$route.meta.header;
            }
        }
    }
</script>